const legalFields = [
  'Family',
  'Commercial',
  'Employment',
  'Corporate',
  'Tax',
  'Intellectual property',
  'Landlord and tenant',
]

const LegalFieldsInfo = () => {
  return (
    <div
      className='flex  flex-col items-center gap-10 self-stretch px-5
            2xl:max-w-[1112px] 2xl:gap-12 2xl:min-w-fit 2xl:px-0 2xl:mx-auto  mt-[220px] lg:mt-[186px] xl:mt-[240px] 2xl:mt-[300px] '
    >
      <h2 className='text-center text-lg leading-6 tracking-wide font-bold text-[#122D5C]  lg:text-2xl lg:leading-8 xl:text-3xl xl:leading-[42px] 2xl:text-4xl 2xl:leading-[54px]'>
        Delivering legal confidence to{' '}
        <span className='text-[#58C1B3]'>200,000+ </span>users since 2020
      </h2>
      <p className='text-[#122D5C] text-sm font-medium leading-normal   lg:text-base lg:font-bold 2xl:leading-6 2xl:tracking-wide'>
        Legal stuff you can get confident about:
      </p>
      <div className='flex justify-center items-start content-start gap-2 self-stretch flex-wrap xl:items-center xl:gap-3'>
        {legalFields.map((field) => (
          <div
            className='flex items-center gap-[10px] px-[16px] py-[4px] rounded-md bg-[#F4F4F4] text-[#101828] 
            text-xs font-medium leading-none lg:text-sm  xl:px-6 xl:py-[6px] xl:rounded-lg xl:text-base xl:leading-6 xl:tracking-wide'
            key={field}
          >
            {field}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LegalFieldsInfo
